export const THL_NURSE_ROLE_NAMES = new Set([
  'Hormonal Health Nurse',
  'Infirmier(ère) en santé hormonale',
  'Personalized Nutrition Nurse',
  'Infirmier(ère) en nutrition personnalisée',
  'Total Health and Life Services Nurse',
  'Infirmier(ère) en services Santé globale et mieux-être',
  'Preventive Health Nurse',
  'Infirmier(ère) en santé préventive',
]);

export const isThlNurse = (roles = []) =>
  (roles || []).some(role => THL_NURSE_ROLE_NAMES.has(role?.role_name));
